import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    page : '',
    subpage : undefined,
}

const breadcrumbSlice = createSlice({
    name:'breadcrumb',
    initialState,
    reducers:{
        setPage(state , action){
            state.page = action.payload;
        },
        setSubpage(state, action){
            state.subpage = action.payload;

        },
        clearSubpage(state){
            state.subpage = undefined;
        }
    },
})

export const {setPage, setSubpage, clearSubpage} = breadcrumbSlice.actions;

export default breadcrumbSlice.reducer